module.exports = __webpack_public_path__ + "img/help.3f6539ce.svg";